// extracted by mini-css-extract-plugin
export default {"buttonErrorSolid":"ButtonErrorSolid_buttonErrorSolid__8JkbK"};